import { Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { ImageOutlined } from "@mui/icons-material";
import { SetActiveTimeline, SetTimelineTranscript, TimelineType } from "../../../Redux/Reducers/redux-slice-timeline";
import { useSelector } from "react-redux";
import EmptyListSlot from "../../Misc/EmptyListSlot";
import { IPreviewTabContentProps } from "./preview-tabs";
import { SubtitlesList } from "../../../Pages/Scribetool/subtitles-list";
import { Caption } from "../../../Pages/Scribetool/scribetool";
import { SecToTimecode } from "../../../Utils/Timecode/ReactPlayer";
import { produce } from "immer";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { DbFileInfos } from "../../../Core/Api/Types/db-file-infos";
import { assetService, cacheService, hlsChunkerService, mediaService } from "../../../Core/Api/services";
import { FileAccessibility } from "../../../Core/Api/Types/file-accessibility";
import { FileCategory } from "../../../Core/Api/Types/file-category";
import { FileStatus } from "../../../Core/Api/Types/file-status";
import { v4 as uuidv4 } from "uuid";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { BaseMetadataType } from "../../../Core/Api/Types/base-metadata-type";
import { LoadingTimeline } from "../../../Pages/Scribetool/loading-timeline";
import { GetFrameRate, GetTimeInSec, GoToFrame } from "../../../Redux/Reducers/redux-slice-react-player";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export const TranscriptTab: React.FC<IPreviewTabContentProps> = (props: IPreviewTabContentProps) => {
  const { t } = useTranslation();
  const { asset } = props;

  const currentTime = useSelector(GetTimeInSec);

  const onClickTimecode = (sec: number) => {
    dispatch(GoToFrame(videoFps * sec));
  };

  const [errors, setErrors] = useState<any[]>([]);
  const [subtitlesData, setSubtitlesData] = useState<any>();
  const [subtitlesDataList, setSubtitlesDataList] = useState<any[]>([]);
  const [availableTtmlFiles, setAvailableTtmlFiles] = useState<DbFileInfos[]>([]);
  const [selectedTtmlFileId, setSelectedTtmlFileId] = useState<number | null>(null);

  const [videoProxy, setVideoProxy] = useState<any>();
  const [videoAsset, setVideoAsset] = useState<DbAssetObjectInfos | null>(null);
  const [captions, setCaptions] = useState<Caption[]>([]);

  const [currentCaptionIndex, setCurrentCaptionIndex] = useState(-1);

  const [loading, setLoading] = useState<boolean>(true);
  const [mode, setMode] = useState<"unknown" | "stp" | "sub" | "project">("unknown");

  const videoSrc = useMemo(() => {
    if ((!videoAsset && mode !== "project") || !videoProxy) return undefined;
    return `${hlsChunkerService.GetServiceUrl()}/${videoProxy.id}/${cacheService.appData?.platformId}`;
  }, [videoProxy]);

  const videoFps = useSelector(GetFrameRate) ?? 24;

  useEffect(() => {
    const captIndex = captions?.findIndex((x) => x.secIn - 0.01 <= currentTime && x.secOut + 0.01 >= currentTime) || -1;
    setCurrentCaptionIndex(captIndex);
  }, [currentTime]);

  const checkForSubProxy = (mode: "project" | "sub") => {
    mediaService.GetFilesByObjectId(asset.id).then((res) => {
      if (!res.success) {
        setErrors((x) => [...x, { step: "ttmlFile", message: res.message }]);
        return;
      }
      const ttmlFileIds =
        res.files?.filter(
          (x) =>
            (x.name?.split(".").pop() === "ttml" || x.name?.split(".").pop() === "vtt") &&
            x.accessibility === FileAccessibility.Disk &&
            x.category === FileCategory.Proxy
        ) ?? [];
      if (ttmlFileIds.length === 0) {
        setErrors((x) => [...x, { step: "ttmlFile", message: t("page:loadingTimeline.error.noLinkedTtmlProxy") }]);
        return;
      }

      setAvailableTtmlFiles(ttmlFileIds || []);

      if (mode === "project") {
        const foundProxy = res.files?.find(
          (x) =>
            x.accessibility === FileAccessibility.Disk &&
            x.category === FileCategory.Proxy &&
            x.status === FileStatus.Online &&
            x.extension === ".mp4"
        );
        if (!foundProxy) {
          setErrors((x) => [...x, { step: "videoProxy", message: t("page:loadingTimeline.error.noLinkedVideoProxy") }]);
          return;
        }
        setVideoProxy(foundProxy);
      }
    });
  };

  const checkForVideoProxy = () => {
    if (!asset || !asset.parentObjectId) return;
    assetService.GetGraph(asset.parentObjectId, false, true, false).then((res) => {
      if (!res.success) {
        setErrors((x) => [...x, { step: "videoAsset", message: res.message }]);
        return;
      }
      const content = res.graph?.childObjects?.find((x) => x.metadata?.find((m) => m.fieldName === "refVideoAssetIds"));
      if (!content) return;
      const ref = content.metadata!.find((m) => m.fieldName === "refVideoAssetIds")?.value;
      const foundVideo = content.childObjects?.find((x) => ref.includes(x.id));
      if (!foundVideo) {
        setErrors((x) => [
          ...x,
          { step: "videoAsset", message: t("page:loadingTimeline.error.videoReferenceNotFound") },
        ]);
        return;
      }
      setVideoAsset(foundVideo);
      getVideoProxy(foundVideo.id);
    });
  };

  const getVideoProxy = (foundVideoId) => {
    mediaService.GetFilesByObjectId(foundVideoId).then((response) => {
      if (!response.success) {
        setErrors((x) => [...x, { step: "videoProxy", message: response.message }]);
        return;
      }
      const foundProxy = response.files?.find(
        (x) =>
          x.accessibility === FileAccessibility.Disk &&
          x.category === FileCategory.Proxy &&
          x.status === FileStatus.Online
      );
      if (!foundProxy) {
        setErrors((x) => [...x, { step: "videoProxy", message: t("page:loadingTimeline.error.noLinkedVideoProxy") }]);
        return;
      }
      setVideoProxy(foundProxy);
    });
  };
  function convertSpeetchToTextToCues(subtitltes) {
    var captions: any[] = [];
    subtitltes.speech.speaker.forEach((x, i) => {
      let sentence: any[] = [];
      x.words.forEach((w, n) => {
        if (sentence.length === 0) sentence.push(w);
        else if (w.start === sentence[sentence.length - 1].end) {
          sentence.push(w);
        } else {
          const sentenceStart = sentence[0].start;
          const sentenceEnd = sentence[sentence.length - 1].end;

          var segmentId = uuidv4();
          captions.push({
            style: "Normal",
            tcIn: SecToTimecode(sentenceStart / videoFps, videoFps),
            tcOut: SecToTimecode(sentenceEnd / videoFps, videoFps),
            secIn: sentenceStart / videoFps,
            secOut: sentenceEnd / videoFps,
            note: "",
            status: "",
            segmentId: segmentId,
            speaker: x.name,
            words: sentence,
          });
          sentence = [w];
        }
      });
    });
    return captions.sort((a, b) => a.secIn - b.secIn);
  }

  function convertSubtitleMetadataToCues(subtitles) {
    var captions: any[] = [];
    subtitles.rows.forEach((row) => {
      var segmentId = uuidv4();
      captions.push({
        style: row.texts && row.texts.length > 0 ? row.texts[0].style : "Normal",
        tcIn: SecToTimecode(row.frameIn / videoFps, videoFps),
        tcOut: SecToTimecode(row.frameOut / videoFps, videoFps),
        secIn: row.frameIn / videoFps,
        secOut: row.frameOut / videoFps,
        note: row.notes,
        status: row.status,
        segmentId: segmentId,
        text: row.texts?.map((t) => t.text).join("\r\n"),
      });
    });
    return captions.sort((a, b) => a.secIn - b.secIn);
  }

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SetActiveTimeline(TimelineType.Transcript));
  }, []);

  const initTextTrack = () => {
    const capt =
      mode === "stp" ? convertSpeetchToTextToCues(subtitlesData) : convertSubtitleMetadataToCues(subtitlesData);
    setCaptions(capt);
    dispatch(SetTimelineTranscript(capt));
  };

  useEffect(() => {
    if (!asset) return;
    // Loading asset

    if (
      asset?.type !== ObjectType.Video &&
      asset?.type !== ObjectType.Subtitle &&
      asset?.type !== ObjectType.ScribeSubtitleProject &&
      asset?.type !== ObjectType.Audio
    ) {
      setErrors((x) => [...x, { step: "asset", message: t("page:error.assetTypeMismatch", { type: asset?.type }) }]);
      return;
    }

    const subtitlesMetadata = asset?.metadata?.find(
      (x) => x.fieldType === BaseMetadataType.DbSpeechToTextMetadataValueInfos
    );

    // Choose mode base on presence of speech to text metadata on asset
    if (subtitlesMetadata) {
      setMode("stp");
      setSubtitlesData(subtitlesMetadata.value);
    } else {
      const newMode = asset.type === ObjectType.ScribeSubtitleProject ? "project" : "sub";
      setMode(newMode);
      checkForSubProxy(newMode);
    }
  }, [asset?.id]);

  useEffect(() => {
    // select first ttml file when found ttml files
    if (!subtitlesData && availableTtmlFiles.length > 0) {
      setSelectedTtmlFileId(availableTtmlFiles[0].id);
      setSubtitlesDataList(availableTtmlFiles.map((x) => undefined));
    }
  }, [availableTtmlFiles, subtitlesData]);

  useEffect(() => {
    if (!selectedTtmlFileId) return;
    // Load sub file as metadata when selected ttml file change
    const foundSubData =
      availableTtmlFiles.findIndex((x) => x.id === selectedTtmlFileId) > -1
        ? subtitlesDataList[availableTtmlFiles.findIndex((x) => x.id === selectedTtmlFileId)]
        : undefined;
    if (!foundSubData)
      mediaService.GetSubtitleFileAsMetadata(selectedTtmlFileId).then((response) => {
        if (!response.success) {
          setErrors((x) => [...x, { step: "subtitlesData", message: response.message }]);
          return;
        }
        setSubtitlesData(response.subtitles);
        setSubtitlesDataList(
          produce((draft) => {
            if (availableTtmlFiles.findIndex((x) => x.id === selectedTtmlFileId) > -1) {
              draft[availableTtmlFiles.findIndex((x) => x.id === selectedTtmlFileId)] = response.subtitles;
            }
          })
        );
      });
    else {
      setSubtitlesData(foundSubData);
    }
  }, [selectedTtmlFileId]);

  useEffect(() => {
    if (!asset || !subtitlesData || videoProxy) return;
    // after loading subtitles data, try to find video proxy
    if (mode === "stp") {
      setVideoAsset(asset);
      getVideoProxy(asset.id);
    } else if (mode === "sub") checkForVideoProxy();
  }, [asset, subtitlesData, videoProxy]);

  useEffect(() => {
    if (videoSrc === "" || !subtitlesData) return;
    initTextTrack();
  }, [videoSrc, subtitlesData]);

  useEffect(() => {
    if (errors.length > 0) {
      setLoading(false);
    }
  }, [errors]);

  return (
    <Stack gap={1} position="relative" sx={{ width: "100%", height: "calc(100% - 88px)", p: 1.5 }}>
      {captions.length > 0 && mode !== "unknown" && errors.length === 0 ? (
        <SubtitlesList
          captions={captions}
          currentCaptionIndex={currentCaptionIndex}
          mode={mode}
          currentTime={currentTime}
          onClickTimecode={onClickTimecode}
          videoFps={videoFps}
        />
      ) : (
        <EmptyListSlot title={t("page:emptyListSlot.title.noTranscriptionData")} icon={<ImageOutlined />} />
      )}

      {loading && (
        <LoadingTimeline
          errors={errors}
          asset={asset}
          availableTtmlFiles={availableTtmlFiles}
          subtitlesData={subtitlesData}
          videoAsset={videoAsset}
          videoProxy={videoProxy}
          setLoading={setLoading}
          mode={mode}
          captions={captions}
        />
      )}
    </Stack>
  );
};
